var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Type } from 'class-transformer';
import { UserWithoutRelationsDto } from '../../../classes/user';
export class VendorProfileDto {
    constructor(initializer) {
        this.id = initializer.id;
        this.name = initializer.name;
        this.type = initializer.type;
        this.authority = initializer.authority;
        this.managerName = initializer.managerName;
        this.phoneNumber1 = initializer.phoneNumber1;
        this.phoneNumber2 = initializer.phoneNumber2;
        this.fax = initializer.fax;
        this.email = initializer.email;
        this.users = initializer.users;
    }
}
__decorate([
    Type(() => UserWithoutRelationsDto),
    __metadata("design:type", Array)
], VendorProfileDto.prototype, "users", void 0);
